import React from 'react';

import content from '../../components/content/Content.m.sass';

import {connect} from 'react-redux';
import {fetchTaxonBySlug, fetchTaxonProductsBySlug} from '../../ducks/taxons';

import {findMenuTaxon} from '../../utils/taxons';

import LocationDispatchingSink from '../locationDispatchingSink/LocationDispatchingSink';
import Meta from '../../components/meta/Meta';
import Content from '../../components/content/Content';
import BreadcrumbsContainer from '../breadcrumbsContainer/BreadcrumbsContainer';
import MenuContainer from '../menuContainer/MenuContainer';
import OnlineSupport from '../../components/onlineSupport/OnlineSupport';
import Reviews from '../../components/reviews/Reviews';
import SeoSection from '../../components/seoSection/SeoSection';

import TrustPilot from '../../components/trustPilot/TrustPilot';
import withMediaQueries from '../withMediaQueries/withMediaQueries';
import GoBack from '../../components/goBack/GoBack';
import ProductList from '../../components/product/ProductList';
import Loader from '../../components/loader/Loader';
import ErrorPage from '../errorPage/ErrorPage';

@withMediaQueries({collapsed: '(max-width: 991px)'}, {collapsed: false})
@connect(({taxons}, {params}) => ({
  taxon: taxons.taxon[params.splat],
  products: taxons.products.all[params.splat]
}))
export default class CategoryPage extends React.PureComponent {
  static fetchData = ({dispatch, params}) => dispatch(fetchTaxonBySlug(params.splat))
    .then(taxon => Promise.all([
      MenuContainer.fetchData({dispatch, menuTaxon: findMenuTaxon(taxon).slug}),
      dispatch(fetchTaxonProductsBySlug('all', params.splat))
    ]));

  componentDidMount() {
    const {dispatch, params, taxon, products} = this.props;

    if (taxon === undefined) {
      dispatch(fetchTaxonBySlug(params.splat));
    }

    if (taxon && products === undefined) {
      dispatch(fetchTaxonProductsBySlug('all', params.splat));
    }
  }

  componentDidUpdate(prevProps) {
    const {dispatch, params, taxon, products} = this.props;

    if (taxon === undefined) {
      dispatch(fetchTaxonBySlug(params.splat));
    }

    if (taxon && products === undefined) {
      dispatch(fetchTaxonProductsBySlug('all', params.splat));
    }
  }

  render() {
    const {collapsed, taxon, products} = this.props;

    if (taxon === false) {
      return <ErrorPage/>;
    }

    const taxonMeta = (taxon && taxon.metatag) || {};

    return (
      <div>
        {!!taxon && (
          <LocationDispatchingSink
            menuTaxon={findMenuTaxon(taxon).slug}
            breadcrumbs={taxon.parents.filter(it => it.level > 0).concat(taxon).sort((a, b) => a.level - b.level)}
          />
        )}

        {!!taxon && (
          <Meta
            title={taxonMeta.pageTitle}
            fallbackTitle={taxon.name}
            description={taxonMeta.description}
            keywords={taxonMeta.keywords}
            image={!!taxon.images.length && taxon.images[0].path}
          />
        )}

        {collapsed && (
          <GoBack/>
        )}

        <Content>
          {!collapsed && (
            <div className={content.content_top}>
              <div className="container">
                <BreadcrumbsContainer/>
              </div>
            </div>
          )}

          <div className="container">
            <div className={content.content_inner}>
              <div className={content.content_row}>
                {!collapsed && (
                  <div className={content.content_sidebar}>
                    <MenuContainer/>
                    <TrustPilot apart/>
                    <OnlineSupport/>
                  </div>
                )}

                {!taxon || !products ? (
                  <Loader page/>
                ) : (
                  <div className={content.content_full}>
                    <h1 className={content.content_header}>
                      {taxonMeta.headTitle || taxon.name}
                    </h1>

                    {!!taxon.description && (
                      <div className={content.content_text}>
                        <p>{taxon.description}</p>
                      </div>
                    )}

                    <div className={content.content_products}>
                      <ProductList products={products}/>
                    </div>

                    {!!taxon.seoText && (
                      <div className={content.content_seo}>
                        <SeoSection content={taxon.seoText}/>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Content>

        <Reviews title="Our reviews"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/categoryPage/CategoryPage.js